import { supabase } from './supabaseClient';
import { logError, logInfo } from './logger';

type TriggerPushNotificationInput = {
  userIds: string[];
  title: string;
  message: string;
  url: string;
  tag?: string;
  kind?: 'badge_unlock' | 'friend_request' | 'direct_message' | 'task_reminder' | 'challenge_invite' | 'challenge_join_request' | 'challenge_join_update' | 'admin_new_signup';
  metadata?: Record<string, unknown> | null;
};

export const triggerPushNotification = async (input: TriggerPushNotificationInput): Promise<boolean> => {
  if (!input.userIds.length) {
    return false;
  }

  const { error } = await supabase.functions.invoke('send-push-notification', {
    body: {
      userIds: input.userIds,
      title: input.title,
      message: input.message,
      url: input.url,
      tag: input.tag || input.kind || 'dopamind-push',
      kind: input.kind || 'badge_unlock',
      metadata: input.metadata || null
    }
  });

  if (error) {
    logError('push', 'Falha ao disparar notificacao push.', error);
    return false;
  }

  logInfo('push', 'Push enviado para fila de entrega.', {
    totalUsers: input.userIds.length,
    kind: input.kind || 'badge_unlock'
  });
  return true;
};
